import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class RequiredOptionPanelSummary extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    options: PropTypes.array.isRequired,
    copyKey: PropTypes.string.isRequired,

    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "project_wizard.resource_panel"
  };

  // -- RENDER -- //

  renderActive() {
    const {
      id,
      name,
      formikProps: { values },
      options,
      copyKey,
      copy
    } = this.props;

    const option = options.find(item => item.value === values[name]);

    return (
      <p>
        <strong>{copy(`${copyKey}.dropdown_label`)}: </strong>
        {option.text}
      </p>
    );
  }

  renderInactive() {
    return null;
  }

  render() {
    const {
      id,
      name,
      formikProps: { values }
    } = this.props;

    if (values[name]) {
      return this.renderActive();
    }

    return this.renderInactive();
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(RequiredOptionPanelSummary);
